module.exports = __webpack_public_path__ + "img/turkcell-foursquare-launch-02.c1d036ff.jpg";